import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import logoAsset from "@/assets/adv3nture-logo.png.asset.json";
const AdV3ntureLogo = ({ className = "" }: { className?: string }) => (
  <img src={logoAsset.url} alt="AdV3nture" className={`h-10 w-auto ${className}`} />
);

const navLinks = [
{ label: "About", href: "/about" },
{ label: "How It Works", href: "/how-it-works" },
{ label: "For Founders", href: "/for-founders" },
{ label: "For Investors", href: "/for-investors" },
{ label: "Security", href: "/security" }];



const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  return (
    <motion.nav
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="fixed top-0 left-0 right-0 z-50 glass"
      aria-label="Main navigation">

      <div className="container mx-auto flex items-center justify-between py-4 px-6">
        <Link to="/" className="flex items-center" aria-label="AdV3nture home">
          <AdV3ntureLogo />
        </Link>
        <div className="hidden lg:flex items-center gap-6">
          {navLinks.map((link) => <Link
              key={link.href}
              to={link.href}
              className={`text-sm transition-colors ${
              location.pathname === link.href ?
              "text-primary font-medium" :
              "text-muted-foreground hover:text-foreground"}`
              }>

              {link.label}
            </Link>
          )}
        </div>
        <div className="hidden lg:flex items-center gap-3">
          <Button asChild variant="ghost" size="sm" className="text-muted-foreground hover:text-foreground">
            <a href="https://app.adv3nture.io" target="_blank" rel="noopener noreferrer">
              Log In
            </a>
          </Button>
          <Button asChild size="sm" className="glow-primary">
            <a href="https://app.adv3nture.io" target="_blank" rel="noopener noreferrer">
              Get Early Access
            </a>
          </Button>
        </div>

        {/* Mobile toggle */}
        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="lg:hidden text-foreground"
          aria-label="Toggle menu">

          {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile menu */}
      <AnimatePresence>
        {mobileOpen &&
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          exit={{ opacity: 0, height: 0 }}
          className="lg:hidden border-t border-border/50 bg-card/95 backdrop-blur-xl">

            <div className="container mx-auto px-6 py-4 flex flex-col gap-3">
              {navLinks.map((link) =>
            <Link
              key={link.href}
              to={link.href}
              onClick={() => setMobileOpen(false)}
              className={`text-sm py-2 transition-colors ${
              location.pathname === link.href ?
              "text-primary font-medium" :
              "text-muted-foreground hover:text-foreground"}`
              }>

                  {link.label}
                </Link>
            )}
              <div className="flex gap-3 pt-2 border-t border-border/50">
                <Button asChild variant="ghost" size="sm" className="text-muted-foreground">
                  <a href="https://app.adv3nture.io" target="_blank" rel="noopener noreferrer">
                    Log In
                  </a>
                </Button>
                <Button asChild size="sm" className="glow-primary">
                  <a href="https://app.adv3nture.io" target="_blank" rel="noopener noreferrer">
                    Get Early Access
                  </a>
                </Button>
              </div>
            </div>
          </motion.div>
        }
      </AnimatePresence>
    </motion.nav>);

};

export default Navbar;